import { AIConfig, AILevel, DEFAULT_AI_CONFIG } from '../ai/types';

/**
 * 種族別AIデフォルト値（Lv5最適設定）
 *
 * tendencies.tsの種族傾向をスライダー値に変換したもの。
 * AIキャラ作成時の初期値として使用する。
 */
export const SPECIES_AI_DEFAULTS: Record<string, AIConfig> = {
  // 剣士（衡騎士）: バランス型
  zaag: {
    aggression: 50, specialPreference: 50, distancePreference: 50,
    stanceTendency: 50, reflectorUsage: 50, riskTolerance: 50,
    patternReading: 60, counterTendency: 55, adaptability: 60,
    metaReading: 50, unpredictability: 25, comboSynergy: 60,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // ゴーレム（巌巨人）: 近距離パワー型
  gardan: {
    aggression: 75, specialPreference: 15, distancePreference: 20,
    stanceTendency: 55, reflectorUsage: 40, riskTolerance: 70,
    patternReading: 45, counterTendency: 40, adaptability: 45,
    metaReading: 35, unpredictability: 20, comboSynergy: 55,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // ウィスプ（星詠霊）: 遠距離特殊型
  roona: {
    aggression: 65, specialPreference: 85, distancePreference: 80,
    stanceTendency: 55, reflectorUsage: 50, riskTolerance: 35,
    patternReading: 65, counterTendency: 50, adaptability: 60,
    metaReading: 55, unpredictability: 25, comboSynergy: 55,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // ワイバーン（天翔）: 中距離柔軟型
  zephyr: {
    aggression: 55, specialPreference: 50, distancePreference: 50,
    stanceTendency: 55, reflectorUsage: 55, riskTolerance: 50,
    patternReading: 65, counterTendency: 60, adaptability: 65,
    metaReading: 55, unpredictability: 30, comboSynergy: 65,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // 大亀（金剛衛）: 守勢壁役
  balga: {
    aggression: 50, specialPreference: 45, distancePreference: 45,
    stanceTendency: 30, reflectorUsage: 75, riskTolerance: 35,
    patternReading: 55, counterTendency: 60, adaptability: 50,
    metaReading: 45, unpredictability: 20, comboSynergy: 50,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // トレント（太古翁）: 守勢持久型
  morsu: {
    aggression: 40, specialPreference: 55, distancePreference: 65,
    stanceTendency: 30, reflectorUsage: 55, riskTolerance: 30,
    patternReading: 55, counterTendency: 50, adaptability: 50,
    metaReading: 45, unpredictability: 20, comboSynergy: 50,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // ミノタウロス（戦修羅）: 超攻撃型
  graon: {
    aggression: 80, specialPreference: 10, distancePreference: 15,
    stanceTendency: 75, reflectorUsage: 30, riskTolerance: 75,
    patternReading: 45, counterTendency: 40, adaptability: 45,
    metaReading: 35, unpredictability: 20, comboSynergy: 60,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // フェニックス（紅蓮魔）: 紙装甲砲撃型
  igna: {
    aggression: 65, specialPreference: 90, distancePreference: 80,
    stanceTendency: 55, reflectorUsage: 40, riskTolerance: 45,
    patternReading: 60, counterTendency: 50, adaptability: 60,
    metaReading: 55, unpredictability: 25, comboSynergy: 55,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // 呪いの人形（傀儡少女）: 遠距離持久型
  alice: {
    aggression: 30, specialPreference: 85, distancePreference: 85,
    stanceTendency: 25, reflectorUsage: 80, riskTolerance: 30,
    patternReading: 55, counterTendency: 65, adaptability: 50,
    metaReading: 50, unpredictability: 35, comboSynergy: 60,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
  // 着ぐるみマスコット（夢幻遊戯）: 近距離一撃型
  mococo: {
    aggression: 90, specialPreference: 15, distancePreference: 10,
    stanceTendency: 85, reflectorUsage: 35, riskTolerance: 85,
    patternReading: 40, counterTendency: 35, adaptability: 40,
    metaReading: 30, unpredictability: 60, comboSynergy: 50,
    lookAheadDepth: 3, opponentModeling: 50, mixedStrategy: 50, resourceOptimization: 50,
    thinkingLevel: AILevel.LV5,
  },
};

/**
 * 種族IDからAIデフォルト値を取得
 * 存在しない種族IDの場合はDEFAULT_AI_CONFIGを返す
 */
export function getSpeciesAIDefault(speciesId: string): AIConfig {
  return SPECIES_AI_DEFAULTS[speciesId] ?? { ...DEFAULT_AI_CONFIG };
}
